import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { encryptTransform } from "redux-persist-transform-encrypt";

import loginReducer from "../Reducers/LoginReducer.ts";
import cantieriReducer from "../Reducers/CantiereReducer.ts";
import committentiReducer from "../Reducers/CommittentiReducer.ts";
import contrattiReducer from "../Reducers/ContrattoQuadroReducer.ts";
import eventiReducer from "../Reducers/EventoReducer.ts";
import referentiReducer from "../Reducers/ReferentiReducer.ts";
import taskReducer from "../Reducers/TaskReducer.ts";
import utentiReducer from "../Reducers/UtentiReducer.ts";
import metodoPagamentoReducer from "../Reducers/MetodoPagamentoReducer.ts";
import statoReducer from "../Reducers/StatoReducer.ts";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "login",
    "stati",
    "metodi",
    "cantieri",
    "committenti",
    "contratti",
    "eventi",
    "referenti",
    "task",
    "utenti",
  ],
  transforms: [encryptTransform({ secretKey: "s3cr3tK3y" })],
};

const combinedReducers = combineReducers({
  login: loginReducer,
  cantieri: cantieriReducer,
  committenti: committentiReducer,
  contratti: contrattiReducer,
  eventi: eventiReducer,
  referenti: referentiReducer,
  task: taskReducer,
  utenti: utentiReducer,
  metodi: metodoPagamentoReducer,
  stati: statoReducer,
});

const rootReducer = (state: any, action: any) => {
  return combinedReducers(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const persistor = persistStore(store);
